"use client";

import { supabase } from '@/utils/supabase/client';

export type CompanyBrand = {
  id: string;
  name: string;
  subdomain: string | null;
  custom_domain?: string | null;
  domain_verified?: boolean | null;
  logo_url?: string | null;
  primary_color?: string | null;
  secondary_color?: string | null;
  status?: string | null;
  created_at?: string | null;
};

export async function resolveTenantByHost(host?: string): Promise<CompanyBrand | null> {
  const currentHost = host || (typeof window !== 'undefined' ? window.location.host : '');
  if (!currentHost) return null;

  // Log the Supabase URL being used by the client for debugging
  console.log('Supabase client URL for tenant resolution:', (supabase as any).supabaseUrl);

  let company: CompanyBrand | null = null;

  // First try exact custom domain match
  const { data: byDomain, error: domainError } = await supabase
    .from("companies")
    .select("id,name,subdomain,custom_domain,domain_verified,logo_url,primary_color,secondary_color,status,created_at")
    .eq("custom_domain", currentHost)
    .maybeSingle();

  if (domainError) {
    console.warn('Error resolving tenant by custom domain:', domainError);
  } else if (byDomain) {
    company = byDomain;
  }

  // If not found by custom domain, try subdomain
  if (!company) {
    const root = "wightwayconnect.uk"; // This should ideally be an environment variable
    let subdomain = null as string | null;
    if (currentHost.endsWith(root)) {
      const parts = currentHost.split(".");
      if (parts.length >= 3) {
        subdomain = parts[0];
      }
    }

    if (subdomain) {
      const { data: bySub, error: subError } = await supabase
        .from("companies")
        .select("id,name,subdomain,custom_domain,domain_verified,logo_url,primary_color,secondary_color,status,created_at")
        .eq("subdomain", subdomain)
        .maybeSingle();

      if (subError) {
        console.warn('Error resolving tenant by subdomain:', subError);
      } else if (bySub) {
        company = bySub;
      }
    }
  }

  return company;
}